// Environment configuration for React app
export const config = {
  playlistApi: {
    url: process.env.REACT_APP_EMOTIFY_PLAYLIST_API_URL || ''
  },
  emotifyApi: {
    url: process.env.REACT_APP_EMOTIFY_API_URL || ''
  },
  reccobeats: {
    apiUrl: process.env.REACT_APP_RECCOBEATS_API_URL || 'https://api.reccobeats.com'
  },
  app: {
    baseUri: process.env.REACT_APP_BASE_EMOTIFY_URI || 'https://emotify.dev'
  },
  ads: {
    // Ad units stay hidden until AdSense approval, so no empty gray boxes show
    // to reviewers or users. Flip on by setting REACT_APP_ADS_ENABLED=true and
    // rebuilding (env vars are baked in at build time). The AdSense <script> in
    // public/index.html loads regardless, since AdSense expects it during review.
    enabled: process.env.REACT_APP_ADS_ENABLED === 'true'
  }
};

// Validate required environment variables
export const validateEnvironment = (): void => {
  if (!config.playlistApi.url) {
    console.warn('REACT_APP_EMOTIFY_PLAYLIST_API_URL is not set.');
  }
  if (!config.emotifyApi.url) {
    console.warn('REACT_APP_EMOTIFY_API_URL is not set.');
  }
};
